import axios from "axios";

const closeExams = (exam_component_id, hook=null, send_email=true) => {
    const token = localStorage.getItem('access_token');
    axios
    .post(
        `${process.env.REACT_APP_API_BASE_URL}/api/close-exams/`,
        { 
            exam_component_id: exam_component_id,
            send_email: send_email,

        },
        {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        }
    )
    .then((response) => {
        if (!hook) return;
        hook(response);
    })
    .catch((error) => {
        if (error.response) {
            console.error("Response error:", error.response.data);
            if (!hook) return;
            hook(error.response);
        } else {
            console.error("Error:", error.message);
        }
    });
}

export default closeExams;